// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"d1a6b289","611":"986b8d49"}[chunkId] + ".chunk.css";
};